module.exports = __webpack_public_path__ + "static/media/wbsrs3.2c4a00d1.svg";